import { createRouter, createWebHistory } from 'vue-router'
import authRoutes from './auth-routes'
import homeRoutes from './home-routes'
import contactsRoutes from './contacts-router'
import followMeRoutes from './follow-me-routes'
import voicemailRoutes from './voicemail-router'
import historicalRoutes from './historical-router'
import meetRoutes from './meet-router'
import notesRoutes from './notes-router'
import settingsRoutes from './settings-routes'
import nebulaAiRoutes from './nebula-ai-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/home/HomePage.vue'),
      meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.home' },
    },
    {
      path: '/checkout/result',
      name: 'checkout.result',
      component: () => import('@/pages/checkout/CheckoutResultPage.vue'),
      meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'Pago' },
    },
    homeRoutes,
    contactsRoutes,
    followMeRoutes,
    voicemailRoutes,
    historicalRoutes,
    nebulaAiRoutes,
    meetRoutes,
    notesRoutes,
    settingsRoutes,
    authRoutes,
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('tokenHub')
  const isAuthRoute = to.meta.requiresAuth === false

  if (!token && !isAuthRoute) {
    return next('/auth/sign-in')
  }

  if (token && isAuthRoute) {
    return next('/')
  }

  next()
})

export default router
